//CSS
import "../../Components/Page/Page.css";


//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";

//Data
import approach from "../../Images/OurStory/OurApproach.png";

const ResNDev: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="Research & Development" />
            <SubSection>
                <ImageComp imageSource={approach} width={"Clamp(18rem, 25vw, 36rem)"} />
                <div className="inv-items">
                    <div className="inv-item">
                        <h4 className="inv-item-title">Extensive Data Collection</h4>
                        <p className="inv-item-body">
                            Over many years we amassed, normalized and curated data from all current
                            production engines and designs patented through {new Date().getFullYear()} including for piston,
                            turbine, rotary, swash-plate, split-cycle, 2- and 4-stroke, CI and SI, and
                            other engine types.
                        </p>
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">Analysis and Validation</h4>
                        <p className="inv-item-body">
                            We analyzed, defined, validated, and recorded the engine and part geometries’
                            effects on efficiency, power, size, and emissions.
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">Predictive Modeling</h4>
                        <p className="inv-item-body">
                            Using predictive modeling, AI, and other data analyzing and engine part design
                            tools, we discovered many new beneficial engine and engine part geometries.
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">Predictive Modeling</h4>
                        <p className="inv-item-body">
                            After modeling and iteration, we subjected the most promising designs to
                            peer-reviews, testing, and global patent searches.
                        </p>{" "}
                    </div>
                </div>
            </SubSection>
        </div>
    );
};

export default ResNDev;
